import React, { useState } from "react";
import {
  Button,
  DropOption,
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../../common/Style";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useForm } from "react-hook-form";
import { CFV, addAlpha } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteF,
  edit,
  seperation,
} from "../../../store/reducers/guestsReducer";
import GenericModal from "../../common/modals/GenericModal";
import telephone from "../../../assets/common/telephone.svg";
import trash from "../../../assets/common/trash.svg";
import girl from "../../../assets/common/girl.svg";
import boy from "../../../assets/common/boy.svg";
import separate from "../../../assets/common/separate.svg";
import call from "../../../assets/common/call.svg";
import tsim from "../../../assets/common/tsim.png";
import tiv from "../../../assets/common/tiv.png";
import glut from "../../../assets/common/glut.png";
import glat from "../../../assets/common/glat.png";
import YesNoModal from "../../common/modals/YesNoModal";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import OWC from "./OWC";
import dropdown from "../../../assets/common/dropdown.svg";

const Edit = ({ guest, init, categories, handleGetAll }) => {
  const { user, isTal } = useSelector((state) => state.authReducer);
  const [showDrop, setShowDrop] = useState(false);

  const dispatch = useDispatch();
  const { guestsLoading } = useSelector((state) => state.guestsReducer);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [showDelete, setShowDelete] = useState(null);
  const [limit, setLimit] = useState(true);
  const [loading, setLoadind] = useState(false);
  const [closeness, setCloseness] = useState(guest.closeness);
  const [show, setShow] = useState(true);
  const [owc, setOwc] = useState(
    guest.owc !== "" && guest.owc !== null ? guest.owc : "קשר"
  );
  const [ans, setAns] = useState(
    guest.ans !== "" && guest.ans !== null ? guest.ans : ""
  );
  const [showDropOwc, setShowDropOwc] = useState(false);
  const [tempNotes, setNotes] = useState(false);
  const [tempAccept, setAccept] = useState(false);
  let dd = `localhost:3000/n?n=` + `${window.btoa(user._id + " " + guest._id)}`;
  console.log(dd);
  const handleOnSelect = (item) => {
    setCloseness(item.id);
  };
  const handleOnSearch = (string, results) => {
    setCloseness(string);
  };

  const handleSeperation = () => {
    dispatch(
      seperation({
        id: guest._id,
        acceptWomen: guest.acceptWomen,
        acceptMen: guest.acceptMen,
      })
    ).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        handleGetAll();
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const handleAnsClick = (num, pos = "") => {
    // if (ans === "M" || ans === "W" || ans === "L")
    // toast.warning("לא ניתן לסמן מענה מכיוון שכבר התקבל דרך הודעה");
    // else {
    setAns(`C${num} - ${pos} נענתה`);
    setShowDrop(false);
    // }
  };

  const onSubmit = async (data) => {
    if (
      user.eventType &&
      ((data?.inviting.length && owc === "קשר") ||
        (data?.inviting.length === 0 && owc !== "קשר"))
    )
      toast.warning("שדה המזמין והקשר באים ביחד - הכל או כלום");
    else if (closeness.length > 1) {
      let phone = data.phone;
      if (phone[0] === "0") phone = phone.substring(1);
      phone = phone.replaceAll("-", "");
      phone = phone.replaceAll(/[^\d]/g, "");
      let reset = false;
      if (guest.phone?.length > 0 && guest.phone !== phone) reset = true;
      let notes = tempNotes !== false ? tempNotes : data.notes;
      let accept;
      let acceptWomen;
      let acceptMen;
      if (user.separation) {
        accept = null;
        acceptWomen =
          data?.acceptWomen?.length < 1 ||
          data.acceptWomen === undefined ||
          data.acceptWomen === ""
            ? null
            : parseInt(data.acceptWomen);
        acceptMen =
          data?.acceptMen?.length < 1 ||
          data.acceptMen === undefined ||
          data.acceptMen === ""
            ? null
            : parseInt(data.acceptMen);
      } else {
        acceptWomen = null;
        acceptMen = null;
        accept =
          data.accept === undefined || data.accept === ""
            ? null
            : parseInt(data.accept);
      }
      if (user.separation && (acceptMen !== null || acceptWomen !== null)) {
        accept = 0;
        accept += acceptWomen !== null ? acceptWomen : 0;
        accept += acceptMen !== null ? acceptMen : 0;
      }
      if (tempAccept !== false) accept = tempAccept;
      // let arrived = data.arrived === undefined ? null : parseInt(data.arrived);
      let transportation =
        data.transportation === undefined
          ? null
          : parseInt(data.transportation);
      let body = {
        phone,
        name: data.name,
        inviting: data.inviting,
        closeness,
        sum: parseInt(data.sum),
        ans: ans === "מענה" ? "" : ans,
        owc: owc === "קשר" ? "" : owc,
        dishes: [
          parseInt(data.glut),
          parseInt(data.tsim),
          parseInt(data.tiv),
          parseInt(data.glat),
        ],
        accept: reset ? null : accept,
        acceptMen: reset ? null : acceptMen,
        acceptWomen: reset ? null : acceptWomen,
        // arrived,
        transportation,
        notes: reset ? "" : notes === undefined ? "" : notes,
        // add table + gifts at be simple
      };
      if (reset) body = { ...body, smsSent: 0, whaSent: 0 };
      dispatch(edit(guest._id, body)).then((res) => {
        if (!res.payload?.error) {
          toast.success("הפעולה בוצעה בהצלחה");
          init();
        } else toast.error(res.payload?.error);
      });
    } else toast.warning("שדה קירבה לא יכול להיות פחות מ 2 תווים");
  };

  const handleDelete = () => {
    setLoadind(true);
    dispatch(deleteF([guest._id])).then((res) => {
      setLoadind(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
      id="form1"
      style={{
        maxHeight: `${window.screen.availHeight * 0.8}px`,
        position: "relative",
      }}
    >
      {user.separation && (
        <img
          onClick={handleSeperation}
          src={separate}
          style={{
            width: "30px",
            position: "absolute",
            left: "10px",
            top: "10px",
            cursor: "pointer",
          }}
        />
      )}
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <FlexRowBetween
          style={{
            // width: "90%",
            margin: "10px auto",
            alignItems: "flex-end",
          }}
        >
          <div
            className="relativeBox"
            style={{
              zIndex: "1",
              width: "65%",
            }}
          >
            <Label>קירבה</Label>
            <ReactSearchAutocomplete
              items={categories}
              onSelect={handleOnSelect}
              onSearch={handleOnSearch}
              placeholder={closeness}
              fuseOptions={{ minMatchCharLength: 1 }}
              showNoResults={false}
              maxResults={show ? 10 : 0}
              styling={{
                searchIconMargin: "0 5px 0 10px",
                borderRadius: "5px",
                width: "100%",
                height: "40px",
                fontFamily: "heb",
              }}
            />
          </div>
          <OverlayTrigger
            placement={"bottom"}
            overlay={
              <Tooltip>
                {show ? "הסתרת השלמות לחיפוש" : "הצגת השלמות לחיפוש"}
              </Tooltip>
            }
          >
            <GenericDiv
              background={"#7b96c4"}
              style={{
                marginLeft: "0",
                padding: "9px 15px",
                marginBottom: "1px",
              }}
              onClick={() => setShow(!show)}
            >
              {show ? "הסתר" : "הצג"}
            </GenericDiv>
          </OverlayTrigger>
        </FlexRowBetween>

        <FlexRowBetween style={{ marginTop: "20px" }}>
          <div style={{ width: "30%" }}>
            <Label>שם מלא</Label>
            <Input
              defaultValue={guest.name}
              type="text"
              {...register("name", {
                required: true,
                minLength: 2,
                maxLength: 50,
              })}
            />
            {CFV("title", "בין 2 ל 50 תווים", errors)}
          </div>

          <div style={{ width: "40%" }}>
            <FlexRowBetween>
              <Label>מס׳ נייד</Label>
              <OverlayTrigger
                placement={"bottom"}
                overlay={
                  <Tooltip>לחיצה תאפשר לשים מספר טלפון קווי לרשומה זו</Tooltip>
                }
              >
                <img
                  onClick={() => setLimit(!limit)}
                  src={telephone}
                  alt="telephone"
                  style={{ width: "21px", marginLeft: "5px" }}
                />
              </OverlayTrigger>
            </FlexRowBetween>
            <Input
              defaultValue={guest.phone}
              {...register("phone", {
                pattern: limit && /^[0]{0,1}[5]{1}[0-9]{8}$/,
              })}
            />
            {CFV("phone", "פורמט מספר פלאפון לא חוקי", errors)}
          </div>

          {guest.phone?.length && (
            <a
              href={
                "tel:" +
                (guest.phone[0] === "0" ? guest.phone : "0" + guest.phone + "")
              }
            >
              <OverlayTrigger
                placement={"top"}
                overlay={<Tooltip>{"חיוג"}</Tooltip>}
              >
                <GenericDiv
                  background={"#7b96c4"}
                  style={{ padding: "7px 7px", marginBottom: "-15px" }}
                >
                  <img alt="call" style={{ width: `15px` }} src={call} />
                </GenericDiv>
              </OverlayTrigger>
            </a>
          )}
        </FlexRowBetween>

        <Label>הערות</Label>
        <TextArea
          defaultValue={guest.notes}
          type="text"
          rows="2"
          {...register("notes", {
            minLength: 0,
            maxLength: 500,
          })}
        />
        {CFV("notes", "עד 500 תווים", errors)}

        <FlexRowBetween style={{ marginTop: "-5px" }}>
          <div style={{ width: "20%" }}>
            <Label>הוזמנו</Label>
            <Input
              defaultValue={guest.sum}
              type="number"
              {...register("sum", {
                required: true,
                min: 1,
                max: user.acceptLimit,
              })}
            />
            {CFV(`sum`, `מספר בין 1 ל ${user.acceptLimit}`, errors)}
          </div>
          <div style={{ width: "20%" }}>
            <Label style={{ borderBottom: "2px solid #7b96c4" }}>אישרו</Label>
            <div style={{ position: "relative", width: "100%" }}>
              <Input
                defaultValue={guest.accept}
                disabled={user.separation}
                type="number"
                {...register("accept", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {ans !== "" && (
                <div
                  style={{
                    position: "absolute",
                    left: "5px",
                    top: "7px",
                    padding: "3px",
                    borderRadius: "2px",
                    background: addAlpha("#7b96c4", 0.2),
                  }}
                >
                  {ans.split("-")[0]}
                </div>
              )}
            </div>
            {CFV(`accept`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
          </div>
          {user.separation ? (
            <>
              <div style={{ width: "20%" }}>
                <FlexRowBetween style={{ width: "min-content" }}>
                  {/* <Label>אישרו</Label> */}
                  <img src={boy} alt="boy" style={{ width: "25px" }} />
                </FlexRowBetween>
                <Input
                  defaultValue={guest.acceptMen}
                  type="number"
                  {...register("acceptMen", {
                    min: 0,
                    max: user.acceptLimit,
                  })}
                />
                {CFV(`acceptMen`, `מספר בין 1 ל ${user.acceptLimit}`, errors)}
              </div>
              <div style={{ width: "20%" }}>
                <FlexRowBetween style={{ width: "min-content" }}>
                  {/* <Label>אישרו</Label> */}
                  <img src={girl} alt="girl" style={{ width: "25px" }} />
                </FlexRowBetween>
                <Input
                  defaultValue={guest.acceptWomen}
                  type="number"
                  {...register("acceptWomen", {
                    min: 0,
                    max: user.acceptLimit,
                  })}
                />
                {CFV(`acceptWomen`, `מספר בין 1 ל ${user.acceptLimit}`, errors)}
              </div>
            </>
          ) : null}

          {/* <div style={{ width: "20%" }}>
            <Label>הגיעו</Label>
            <Input
              defaultValue={guest.arrived}
              type="number"
              {...register("arrived", {
                min: 0,
                max: user.acceptLimit,
              })}
            />
            {CFV(`arrived`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
          </div> */}

          {user.transportation && (
            <div style={{ width: "20%" }}>
              <Label>הסעה</Label>
              <Input
                defaultValue={guest.transportation}
                type="number"
                {...register("transportation", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(
                `transportation`,
                `מספר בין 0 ל ${user.acceptLimit}`,
                errors
              )}
            </div>
          )}
        </FlexRowBetween>

        {user.specialDishes && (
          <FlexRowBetween>
            <div style={{ width: "20%" }}>
              <img
                src={glut}
                alt="glut"
                style={{ width: "35px", marginBottom: "10px" }}
              />
              <Input
                defaultValue={guest.dishes[0]}
                type="number"
                {...register("glut", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(`glut`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
            </div>

            <div style={{ width: "20%" }}>
              <img
                src={tsim}
                alt="tsim"
                style={{ width: "40px", marginTop: "-11px" }}
              />
              <Input
                style={{ marginTop: "7px" }}
                defaultValue={guest.dishes[1]}
                type="number"
                {...register("tsim", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(`tsim`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
            </div>

            <div style={{ width: "20%" }}>
              <img
                src={tiv}
                alt="tiv"
                style={{ width: "40px", marginTop: "-11px" }}
              />
              <Input
                style={{ marginTop: "7px" }}
                defaultValue={guest.dishes[2]}
                type="number"
                {...register("tiv", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(`tiv`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
            </div>

            <div style={{ width: "20%" }}>
              <img
                src={glat}
                alt="glat"
                style={{ width: "35px", marginBottom: "10px" }}
              />
              <Input
                defaultValue={guest.dishes[3]}
                type="number"
                {...register("glat", {
                  min: 0,
                  max: user.acceptLimit,
                })}
              />
              {CFV(`glat`, `מספר בין 0 ל ${user.acceptLimit}`, errors)}
            </div>
          </FlexRowBetween>
        )}

        {user.eventType ? (
          <FlexRowBetween
            style={{
              // marginBottom: "20px",
              alignItems: "center",
            }}
          >
            <div style={{ position: "relative", width: "65%" }}>
              <Label>המזמין</Label>
              <Input
                defaultValue={guest.inviting}
                type="text"
                {...register("inviting", {
                  minLength: 2,
                  maxLength: 50,
                })}
              />
              {CFV("inviting", "בין 2 ל 50 תווים", errors)}
            </div>
            <OverlayTrigger
              placement={"bottom"}
              overlay={<Tooltip>{"הקשר של בעל/ת השמחה למזמין"}</Tooltip>}
            >
              <GenericDiv
                background={"#7b96c4"}
                style={{
                  position: "relative",
                  height: "30px",
                  padding: "19.5px 10px",
                  marginTop: "7px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropOwc(!showDropOwc);
                }}
              >
                <div>{owc}</div>
                <img
                  src={dropdown}
                  alt={"dropdown"}
                  style={{ width: "25px", marginLeft: "-7px" }}
                />
                {showDropOwc && (
                  <OWC
                    setOwc={setOwc}
                    setShowDropOwc={setShowDropOwc}
                    top={"-370%"}
                  />
                )}
              </GenericDiv>
            </OverlayTrigger>
          </FlexRowBetween>
        ) : isTal ? (
          <FlexRowBetween
            style={{
              alignItems: "center",
            }}
          >
            <div style={{ position: "relative", width: "65%" }}>
              <Label>הוספת תיאור על מנת שהאורח יבין במי מדובר</Label>
              <Input
                defaultValue={guest.inviting}
                type="text"
                {...register("inviting", {
                  minLength: 2,
                  maxLength: 50,
                })}
              />
              {CFV("inviting", "בין 2 ל 50 תווים", errors)}
            </div>
          </FlexRowBetween>
        ) : null}

        {isTal && (
          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip>{"מענה"}</Tooltip>}
          >
            <GenericDiv
              background={"#7b96c4"}
              style={{ position: "relative", marginBottom: "20px" }}
              onClick={(e) => {
                e.stopPropagation();
                setShowDropOwc(false);
                setShowDrop(!showDrop);
              }}
            >
              <div>{ans === "" ? "מענה" : ans}</div>
              <img
                src={dropdown}
                alt={"dropdown"}
                style={{ width: "25px", marginLeft: "-7px" }}
              />
              {showDrop && isTal && (
                <div
                  style={{
                    position: "absolute",
                    right: "0",
                    bottom: "130%",
                    zIndex: 1,
                    color: "#7b96c4",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    padding: "10px",
                    fontSize: "14px",
                    boxShadow: "0 2px 4px gray",
                  }}
                >
                  <FlexRowBetween>
                    <FlexRowBetween>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(1)}
                        style={{ padding: "3px 8px" }}
                      >
                        כן
                      </DropOption>
                      <div style={{ marginLeft: "7px", marginRight: "9px" }}>
                        C1
                      </div>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(1, "לא ")}
                        style={{ padding: "3px 7px" }}
                      >
                        לא
                      </DropOption>
                    </FlexRowBetween>
                  </FlexRowBetween>
                  <FlexRowBetween style={{ marginTop: "15px" }}>
                    <FlexRowBetween>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(2)}
                        style={{ padding: "3px 8px" }}
                      >
                        כן
                      </DropOption>
                      <div style={{ marginLeft: "7px", marginRight: "9px" }}>
                        C2
                      </div>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(2, "לא ")}
                        style={{ padding: "3px 7px" }}
                      >
                        לא
                      </DropOption>
                    </FlexRowBetween>
                  </FlexRowBetween>
                  <FlexRowBetween style={{ marginTop: "15px" }}>
                    <FlexRowBetween>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(3)}
                        style={{ padding: "3px 8px" }}
                      >
                        כן
                      </DropOption>
                      <div style={{ marginLeft: "7px", marginRight: "9px" }}>
                        C3
                      </div>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(3, "לא ")}
                        style={{ padding: "3px 7px" }}
                      >
                        לא
                      </DropOption>
                    </FlexRowBetween>
                  </FlexRowBetween>
                  <FlexRowBetween style={{ marginTop: "15px" }}>
                    <FlexRowBetween>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(4)}
                        style={{ padding: "3px 8px" }}
                      >
                        כן
                      </DropOption>
                      <div style={{ marginLeft: "7px", marginRight: "9px" }}>
                        C4
                      </div>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(4, "לא ")}
                        style={{ padding: "3px 7px" }}
                      >
                        לא
                      </DropOption>
                    </FlexRowBetween>
                  </FlexRowBetween>
                  <FlexRowBetween style={{ marginTop: "15px" }}>
                    <FlexRowBetween>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(5)}
                        style={{ padding: "3px 8px" }}
                      >
                        כן
                      </DropOption>
                      <div style={{ marginLeft: "7px", marginRight: "9px" }}>
                        C5
                      </div>
                      <DropOption
                        shadow={"#7b96c4"}
                        onClick={() => handleAnsClick(5, "לא ")}
                        style={{ padding: "3px 7px" }}
                      >
                        לא
                      </DropOption>
                    </FlexRowBetween>
                  </FlexRowBetween>
                </div>
              )}
            </GenericDiv>
          </OverlayTrigger>
        )}

        {isTal && (
          <FlexRowBetween
            style={{
              // width: "90%",
              margin: "0 auto",
              marginBottom: "30px",
              fontSize: "12px",
            }}
          >
            <button
              type="submit"
              form="form1"
              style={{
                fontSize: "12px",
                color: "black",
                border: "2px solid silver",
                padding: "4px 9px",
                borderRadius: "3px",
              }}
              onClick={() => setAccept(0)}
            >
              0
            </button>
            {!user.separation && (
              <>
                <button
                  type="submit"
                  form="form1"
                  style={{
                    fontSize: "12px",
                    color: "black",
                    border: "2px solid silver",
                    padding: "4px 9px",
                    borderRadius: "3px",
                  }}
                  onClick={() => setAccept(1)}
                >
                  1
                </button>
                <button
                  type="submit"
                  form="form1"
                  style={{
                    fontSize: "12px",
                    color: "black",
                    border: "2px solid silver",
                    padding: "4px 9px",
                    borderRadius: "3px",
                  }}
                  onClick={() => setAccept(2)}
                >
                  2
                </button>
              </>
            )}
            <button
              type="submit"
              form="form1"
              style={{
                fontSize: "12px",
                color: "black",
                border: "2px solid silver",
                padding: "4px 7px",
                borderRadius: "3px",
              }}
              onClick={() =>
                setNotes(
                  "לא יודעים כרגע, לא להתקשר יותר - יעדכנו בקישור במידה ויהיה שינוי"
                )
              }
            >
              לא להתקשר + יעדכנו
            </button>
          </FlexRowBetween>
        )}
        {isTal && (
          <FlexRowBetween
            style={{
              // width: "90%",
              margin: "0 auto",
              marginBottom: "30px",
              fontSize: "12px",
            }}
          >
            <button
              type="submit"
              form="form1"
              style={{
                fontSize: "12px",
                color: "black",
                border: "2px solid silver",
                padding: "4px 7px",
                borderRadius: "3px",
              }}
              onClick={() => {
                setNotes(
                  "לא לקחת בחשבון כרגע, יעדכנו בקישור במידה ויהיה שינוי"
                );
                setAccept(0);
              }}
            >
              0 + יעדכנו
            </button>
            <button
              type="submit"
              form="form1"
              style={{
                fontSize: "12px",
                color: "black",
                border: "2px solid silver",
                padding: "4px 7px",
                borderRadius: "3px",
              }}
              onClick={() => {
                setNotes("טעות במספר");
                setAccept(0);
              }}
            >
              טעות
            </button>

            <button
              type="submit"
              form="form1"
              style={{
                fontSize: "12px",
                color: "black",
                border: "2px solid silver",
                padding: "4px 7px",
                borderRadius: "3px",
              }}
              onClick={() => setNotes("מספר לא מחובר")}
            >
              מספר לא מחובר
            </button>
          </FlexRowBetween>
        )}

        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button
            background={
              "linear-gradient(to right, rgba(41,59,90,0.95), rgba(123,150,196,0.95), rgba(123,150,196,0.95))"
            }
            style={{ width: "100%" }}
            type="submit"
            form="form1"
          >
            שמירה
          </Button>
          <GenericDiv
            onClick={() => setShowDelete(true)}
            background={"rgba(41,59,90,0.95)"}
            style={{ marginRight: "20px", padding: "9px 10px" }}
          >
            <img src={trash} alt="trash" style={{ width: "21px" }} />
          </GenericDiv>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}
      {guestsLoading && <OpacityLoading />}

      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת רשומה"}
              body={"האם את/ה בטוח/ה שברצונך למחוק רשומה זו?"}
              no={setShowDelete}
              yes={handleDelete}
            />
          }
        />
      )}
    </PopupForm>
  );
};

export default Edit;
